﻿import 'reflect-metadata';
import type { IUserFsrsCardService, IQuizzService, INewsContentService } from '@lingvo-news/contracts';
import { ICurrentUserStore } from '../infrastructure/auth/current-user-store';
import {
	resolveContentService,
	resolveCurrentUserStore,
	resolveQuizzService,
} from './service-container';

export function getCurrentUserStore(): ICurrentUserStore {
	return resolveCurrentUserStore();
}
